import Buypoint from '@/pages/Buypoint'

export default {
  path: '/buypoint',
  name: 'Buypoint',
  component: Buypoint,
  
}



// WEBPACK FOOTER //
// ./src/router/buypoint.js